import { DispatchEvent, StoreItem, StoreNative } from '../Store';
import { IAuthentication } from '../../services';
import * as ACTIONS from './authentication.constants';
import { APPLICATION_DISCONNECTED } from '../application/application.constants';

const defaultState: StoreNative<IAuthentication> = {
    value: null,
    isLoaded: true,
    hasError: false,
    isLoading: false,
};

export function authenticationReducer(
    state: StoreNative<IAuthentication> = new StoreNative<IAuthentication>(),
    action: DispatchEvent<IAuthentication>
) {
    let newState = state;

    if (action && action.type) {
        switch (action.type) {
            case ACTIONS.AUTHENTICATION_LOAD:
                newState = Object.assign({}, defaultState);
                newState.value = action.payload;
                newState.isLoaded = false;
                newState.isLoading = true;
                break;
            case ACTIONS.AUTHENTICATION_LOAD_SUCCESS:
                newState = Object.assign({}, defaultState);
                newState.value = action.payload;
                newState.isLoaded = true;
                newState.isLoading = false;
                break;
            case ACTIONS.AUTHENTICATION_LOAD_ERROR:
                newState = Object.assign({}, defaultState);
                newState.value = action.payload;
                if (newState.value) {
                    newState.value.isConnected = false;
                    newState.value.isAuth = false;
                }
                newState.isLoading = false;
                newState.hasError = true;
                newState.isLoaded = true;
                break;
            case APPLICATION_DISCONNECTED:
                newState.value = Object.assign({}, newState.value, { isConnected: false, roles: [] });
                newState.isLoading = false;
                newState.isLoaded = true;
                break;
        }
    }

    return newState;
}